import apiHandler from "../core/apiHandler";

const productPanelApi = apiHandler('product-panel');
export default productPanelApi;